import { useRouter } from "next/router";
import React from "react";

import FAQContainer from "./brandRefresh/faqs/faq-container";
import BasicCards from "./sections/basic-cards";
import Document from "./sections/document";
import FAQ from "./sections/faq";
import IconRows from "./sections/icon-rows";
import IconStacks from "./sections/icon-stacks";
import ImageCards from "./sections/image-cards";
import LargeImageCards from "./sections/large-image-cards";
import LargeTeasers from "./sections/large-teasers";
import MediumTeasers from "./sections/medium-teasers";
import RichText from "./sections/rich-text";
import Stacks from "./sections/stacks";
import Teasers from "./sections/teasers";
import AppBlock from "./updated-sections/app-block";
import DoubleAppBlock from "./updated-sections/app-block-double";
import BasicHalfText from "./updated-sections/basic-half-text";
import BasicHero from "./updated-sections/basic-hero";
import BasicText from "./updated-sections/basic-text";
import CircleHero from "./updated-sections/circle-hero";
import Contact from "./updated-sections/contact";
import ContactForm from "./updated-sections/contact-form";
import Cta from "./updated-sections/cta";
import DoubleCardBlock from "./updated-sections/double-card-block";
import Fx from "./updated-sections/fx";
import FxRefresh from "./updated-sections/fx-refresh";
import HalfTextUpdated from "./updated-sections/half-text";
import HeroUpdated from "./updated-sections/hero";
import ProductHero from "./updated-sections/product-hero";

// Map Strapi sections to section components
const sectionComponents = {
  ComponentSectionsRichText: RichText,
  ComponentSectionsBasicCards: BasicCards,
  ComponentSectionsImageCards: ImageCards,
  ComponentSectionsLargeImageCards: LargeImageCards,
  ComponentSectionsStacks: Stacks,
  ComponentSectionsIconStacks: IconStacks,
  ComponentSectionsIconRows: IconRows,
  ComponentSectionsTeasers: Teasers,
  ComponentSectionsMediumTeasers: MediumTeasers,
  ComponentSectionsLargeTeasers: LargeTeasers,
  ComponentSectionsDocument: Document,
  ComponentSectionsQuestions: FAQ,
  //Updated components for V2
  ComponentUpdatedSectionsHero: HeroUpdated,
  ComponentSectionsDoubleCardBlock: DoubleCardBlock,
  ComponentUpdatedSectionsHalfText: HalfTextUpdated,
  ComponentUpdatedSectionsAppBlock: AppBlock,
  ComponentUpdatedSectionsProductHero: ProductHero,
  ComponentUpdatedSectionsCta: Cta,
  ComponentUpdatedSectionsDoubleAppBlock: DoubleAppBlock,
  ComponentUpdatedSectionsCircleHero: CircleHero,
  ComponentUpdatedSectionsBasicText: BasicText,
  ComponentUpdatedSectionsBasicHalfText: BasicHalfText,
  ComponentUpdatedSectionsContactForm: ContactForm,
  ComponentUpdatedSectionsBasicHero: BasicHero,
  ComponentUpdatedSectionsContact: Contact,
  ComponentUpdatedSectionsFx: Fx,
  // update Refresh UI
  ComponentRefreshSectionsFx: FxRefresh,
  ComponentRefreshSectionsQuestions: FAQContainer,
};
// Display a section individually
const Section = ({ sectionData, openLiveChat }) => {
  // Prepare the component
  const SectionComponent = sectionComponents[sectionData.__typename];
  if (!SectionComponent) {
    return null;
  }

  // Display the section
  return <SectionComponent data={sectionData} openLiveChat={openLiveChat} />;
};

const PreviewModeBanner = ({ versionsAvailable, version }) => {
  const router = useRouter();

  return (
    <div className="py-4 bg-red-600 text-red-100 font-semibold uppercase tracking-wide">
      <div className="container">
        Preview mode is on.{" "}
        <a
          className="underline"
          href={`/api/exit-preview?redirect=${router.asPath}`}
        >
          Turn off
        </a>
        {versionsAvailable.length > 1 ? (
          <p>
            Version {version} - Other page versions available!
            {versionsAvailable
              .sort(function (a, b) {
                return b - a;
              })
              .map((v, i) => {
                return (
                  <React.Fragment key={i}>
                    {v === version ? null : (
                      <button
                        onClick={() =>
                          router.push(
                            router.asPath.split("?")[0] + "?version=" + v,
                          )
                        }
                        className="float-right text-red-600 px-2.5 bg-white"
                      >
                        {v}
                      </button>
                    )}
                  </React.Fragment>
                );
              })}
          </p>
        ) : null}
      </div>
    </div>
  );
};

// Display the list of sections
const Sections = ({
  sections,
  preview,
  versionsAvailable,
  version,
  openLiveChat,
}) => {
  return (
    <div className="flex flex-col">
      {/* Show a banner if preview mode is on */}
      {preview && (
        <PreviewModeBanner
          version={version}
          versionsAvailable={versionsAvailable}
        />
      )}
      {/* Show the actual sections */}
      {sections.map((section, index) => {
        return (
          <Section
            openLiveChat={openLiveChat}
            sectionData={{ ...section, index: index }}
            key={`${section.__typename}${section.id}`}
          />
        );
      })}
    </div>
  );
};

export default Sections;
